import { FooterRoot } from './Footer';
import { FooterButton } from './footer-button/FooterButton';

export const Footer = {
	Root: FooterRoot,
	Button: FooterButton,
};
